<template>
  <div class="editor-container">
    <div id="editor"></div>
  </div>
</template>
<script>
import wangEditor from "wangeditor";
import OSS from "ali-oss";
import { getOSSConfig } from "@/api/ossImageUploader";

export default {
  // @Prop() ori!: any;
  // disable 是否只读
  props: ["ori", "disable"],
  data() {
    return {
      editor: null,
    };
  },
  mounted() {
    const _t = this;
    _t.getdata();
  },
  methods: {
    getdata() {
      const self = this;
      self.editor = new wangEditor("#editor");
      self.editor.config.uploadImgMaxLength = 1;
      self.editor.config.excludeMenus = ["emoticon", "video"];
      self.editor.config.onchange = function (newHtml) {
        self.$emit("handle-change", newHtml);
        self.$emit("update:ori", newHtml);
      };
      self.editor.config.customUploadImg = function (resultFiles, insertImgFn) {
        getOSSConfig().then((res) => {
          if (res.error_code == 0) {
            const prefix = res.data.object_name_prefix;
            const cdn_url = res.data.cdn_url;
            const callback = res.data.callback;
            const client = new OSS({
              accessKeyId: res.data.access_key_id,
              accessKeySecret: res.data.access_key_secret,
              stsToken: res.data.security_token,
              region: "oss-cn-shenzhen",
              bucket: res.data.bucket,
            });
            client
              .put(prefix + resultFiles[0].name, resultFiles[0], {
                callback: {
                  url: callback.callback_url,
                  host: callback.callback_host,
                  body: callback.callback_body,
                  contentType: callback.callback_body_type,
                },
              })
              .then(function (result) {
                if (result.data.code == "Ok") {
                  insertImgFn(cdn_url + "/" + result.data.object);
                }
              })
              .catch(function (err) {});
          }
        });
      };
      self.editor.create();
      if (this.disable) {
        self.editor.disable();
      }
      if (this.ori) {
        const oriText = this.ori.replace(/max-width:100%!;/, "max-width:100%;");
        self.editor.txt.html(oriText);
      }
    },
  },
  // @Watch("ori", { immediate: false, deep: false })
  // onOriginChange(n: string, o: string) {
  //   const self = this as any;
  //   if (o === "") {
  //     const oriText = n.replace(/max-width:100%!;/, "max-width:100%;");
  //     self.editor.txt.html(oriText);
  //   }
  // }
  watch: {
    ori: {
      handler(n, o) {
        if (!this.ori) return;
        const self = this;
        if (o === "") {
          const oriText = n.replace(/max-width:100%!;/, "max-width:100%;");
          self.editor.txt.html(oriText);
        }
      },
      immediate: false,
      deep: false,
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ #editor {
  .w-e-toolbar {
    z-index: 1001 !important;
  }
  .w-e-text-container {
    z-index: 1000 !important;
  }
}
</style>
